import { createUseStyles } from "react-jss"

import { boldFont, textSize } from "@portal/kit/pkg/styles"

export default createUseStyles(theme => ({
  container: {
    padding: "16px 0",
    display: "flex"
  },
  offer: {
    flexGrow: 1,
    alignItems: "center",
    ...textSize(14, 19),
    "& p": {
      marginBottom: 16,
    },
    "& strong": {
      ...boldFont(),
    }
  },
}))
